import { render, staticRenderFns } from "./alertError.vue?vue&type=template&id=8eff8bc8&scoped=true&"
import script from "./alertError.vue?vue&type=script&lang=js&"
export * from "./alertError.vue?vue&type=script&lang=js&"
import style0 from "./alertError.vue?vue&type=style&index=0&id=8eff8bc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eff8bc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8eff8bc8')) {
      api.createRecord('8eff8bc8', component.options)
    } else {
      api.reload('8eff8bc8', component.options)
    }
    module.hot.accept("./alertError.vue?vue&type=template&id=8eff8bc8&scoped=true&", function () {
      api.rerender('8eff8bc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alertError.vue"
export default component.exports